export const SHARED_BUSINESS_FLOW_PROCESS_FLOW_CUSTOMER_SUPPORT_TYPE = 'CustomerSupport';
